import { useEffect } from "react";
import { useHarmonyEvents } from "./EventManager";

function HarmonyMenu() {
  useHarmonyEvents();

  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://harmonylabs-org-menu.netlify.app/menu-component.js";
    script.async = true;
    script.setAttribute("type", "module");
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <menu-component
      title={"Poverty Media Feeds"}
      home={false}
      closed={true}
      navID={3}
    />
  );
}

export default HarmonyMenu;
